/**
 * valida si el producto tiene precios con hosting gratis
 * solo OpenXchange con periodicidades de 1 o 6 meses no aplica
 * @param {Item} item de ResumenData
 * @returns {bool}
 */
const isProductWithHosting = (item) => {
  let flag = true;

  // si es un producto OpenXchange
  if (item?.isOX) {
    const resultado = String(item?.periodo).match(/\d+/); // Busca un número en la cadena
    const periodo = resultado ? parseInt(resultado[0], 10) : item?.periodo; // Devuelve el número o el periodo si no hay coincidencias
    // si el periodo corresponde a 1 o 6, se agrega precio sin hosting
    switch (periodo) {
      case 1:
      case 6:
        flag = false;
        break;
    }
  }

  // si es un producto WordPress
  if (item?.isWP) {
    const resultado = String(item?.periodo).match(/\d+/); // Busca un número en la cadena
    const periodo = resultado ? parseInt(resultado[0], 10) : item?.periodo; // Devuelve el número o el periodo si no hay coincidencias
    // si el periodo corresponde a 1, se agrega precio sin hosting
    switch (periodo) {
      case 1:
        flag = false;
        break;
    }
  }

  // si es un transferencia sola desde landing transfersearch
  if (item?.isTransfer) {
    flag = false;
  }

    // agregar mas validaciones si se requiere!


  return flag;
};

export default isProductWithHosting;
